import { Link, useLocation } from "react-router-dom";

const NavItem = ({ icon, hlink, title }) => {
  const location = useLocation();
  const isActive =
    location.pathname === hlink ||
    (hlink !== "/" && location.pathname.startsWith(hlink));

  return (
    <li className="nav-item">
      <Link className={`nav-link ${isActive ? "active" : ""}`} to={hlink}>
        <div className="nav-link-icon">
          <i className="material-icons">{icon}</i>
        </div>
        {title && <span className="nav-link-text">{title}</span>}
      </Link>
    </li>
  );
};

export default NavItem;
